import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OutlineState {
  isOutlineGenerated: boolean;
}

const initialState: OutlineState = {
  isOutlineGenerated: false,
};

const outlineSlice = createSlice({
  name: 'outline',
  initialState,
  reducers: {
    setIsOutlineGenerated: (state, action: PayloadAction<boolean>) => {
      state.isOutlineGenerated = action.payload;
    },
  },
});

export const { setIsOutlineGenerated } = outlineSlice.actions;
export default outlineSlice.reducer;